export default __webpack_public_path__ + "static/media/email.43066d80.png";